import { render, staticRenderFns } from "./2026Leaderboard.vue?vue&type=template&id=4e893ecf&"
import script from "./2026Leaderboard.vue?vue&type=script&lang=js&"
export * from "./2026Leaderboard.vue?vue&type=script&lang=js&"
import style0 from "./2026Leaderboard.vue?vue&type=style&index=0&id=4e893ecf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports